/**
 * Code generated by "npm run build-assets"
 * Figma URL: https://nda.ya.ru/t/WQoAxhRw6UejjN
 */

import {ImageAssetMeta, SrcSet} from '@yandex-delivery/assets'

import img1x from './cargo_new_year@1x.png'
import img2x from './cargo_new_year@2x.png'
import img3x from './cargo_new_year@3x.png'

export const cargoNewYear: ImageAssetMeta = {
  width: 35,
  height: 69,
  srcSet: new SrcSet(img1x, img2x, img3x),
}
